import React from "react";
import { Box, Link } from "@mui/material";
import { useNavigate } from "react-router-dom";

export function BackLink({
  label,
  navigateTo,
  icon: Icon,
  iconPosition = "front",
  disabled = false,
  sx,
  iconColor = "var(--blue-400)",
  iconSize = 20,
  iconStyle = { fontWeight: "medium" },
  showIcon = true,
  action,
  onClick,
  modalComponent = null,
}) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (disabled) return;
  
    if (action && typeof onClick === "function") {
      onClick({
        type: "action",
        action: action,   // send correct action
        data: { fieldName: label },  // extra info
      });
      return;
    }
  
    if (navigateTo) {
      navigate(navigateTo);
    }
  };
  

  const IconComponent =
    Icon && showIcon
      ? React.createElement(Icon, {
          color: disabled ? "var(--gray-500)" : iconColor,
          size: iconSize,
          style: {
            ...iconStyle,
            marginRight: iconPosition === "front" ? "8px" : 0,
            marginLeft: iconPosition === "back" ? "8px" : 0,
          },
        })
      : null;

  return (
    <Box sx={{ ...sx }}>
      <Link
        underline="hover"
        onClick={handleClick}
        variant="bodyMedium"
        sx={{
          color: disabled ? "var(--gray-500)" : "var(--link-blue)",
          cursor: disabled ? "not-allowed" : "pointer",
          display: "flex",
          alignItems: "center",
          opacity: disabled ? 0.6 : 1,
          pointerEvents: disabled ? "none" : "auto",
          flexDirection: iconPosition === "back" ? "row-reverse" : "row",
        }}
      >
        {IconComponent}
        {label}
      </Link>
    </Box>
  );
}
